import { List } from "immutable"
import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { fromJSX, IOWidget, Updater, Widget } from "widgets-for-react"
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod"
import { InnerHtmlWrapper } from "../../../utils/InnerHtmlWrapper"
import { CMSState, mediaBlockNestedData, quoteBlockNestedData, textBlockNestedData } from "../types.gen"
import { getClassName } from "../utils.gen"

export type TextReadMoreCopy = {
  more: string,
  less: string
}

export type TextReadMoreBlockProps = {
  index: number
  title?: React.ReactNode
  text: string
  open: boolean
  readmore_blocks: List<textBlockNestedData | mediaBlockNestedData | quoteBlockNestedData>
  copy: TextReadMoreCopy
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type TextReadMoreBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  readmore_classname: string
  readmore_clickable_classname: string
  readmore_label_classname: string
}>

export function TextReadMoreBlock(
  props: TextReadMoreBlockProps,
  options?: { style?: TextReadMoreBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (s: CMSState) =>
    fromJSX(setState => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('textMore', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className={getClassName(options, "block_classname", "container")}
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className={getClassName(options, "inner_classname", "py-5")}>
            {props.title && (
              <header className={getClassName(options, "header_classname", "")}>
                <h2 className={getClassName(options, "title_classname", "mb-3")}>{props.title}</h2>
              </header>
            )}

            <div className={getClassName(options, "content_classname", "")}>
              {/* <div className={getClassName(options, "text_classname", "")} dangerouslySetInnerHTML={{ __html: props.text }} /> */}
              <InnerHtmlWrapper className={getClassName(options, "text_classname", "")} text={props.text} />
            </div>

            <div id={options && options.key ? `a11y-${options.key}-more` : `a11y-block-${props.index}-more`} aria-hidden={!props.open} className={getClassName(options, "readmore_classname", props.open ? '' : 'd-none')}>
              {/* {props.readmore_blocks.map((block, index) => renderBlock<CustomBlockData, never>(block, getMockedBlockRenderer(), _ => { }, `${options && options.key ? options.key : props.index}-${index}`)(s).run(() => { }))} */}
            </div>

            {
              ReadMoreToggler(
                {
                  open: props.open,
                  copy: props.copy,
                  index: props.index
                },
                options
              ).run(action => {
                setState(s1 => {
                  let currentBlock = s1.blocks.get(props.index)
                  if (currentBlock.kind === "textReadMoreBlock") {
                    currentBlock = {
                      ...currentBlock,
                      value: [
                        {
                          ...currentBlock.value[0],
                          open: action(currentBlock.value[0].open)
                        },
                        currentBlock.value[1]
                      ]
                    }
                  }
                  return { ...s1, blocks: s1.blocks.set(props.index, currentBlock) }
                })
              })
            }
          </div>
        </InView>
      )
    )
}

function ReadMoreToggler(
  props: { open: boolean, copy: TextReadMoreCopy, index: number },
  options?: { style?: TextReadMoreBlockStyle; key?: string }
): Widget<Updater<boolean>> {
  return fromJSX(setState =>
      <button
        className={getClassName(options, "readmore_clickable_classname", "btn btn-dark d-block mx-auto")}
        aria-controls={options && options.key ? `a11y-${options.key}-more` : `a11y-block-${props.index}-more`}
        aria-expanded={props.open}
        onClick={() => setState(s => !s)}
      >
        <span className={getClassName(options, "readmore_label_classname", "")}>{props.open ? props.copy.less : props.copy.more}</span>
      </button>
  )
}
